var $ = require('jquery');
var backDiv = null,
    popDiv = null;
var msgbox_tpl = require('../tpl/msgbox.tpl');
var active_cfg = window.active_cfg;
function showmsg(msg, opts) {
    exit();
    opts = opts || {};
    $('#act_msgbox_common').length ? popDiv = $('#act_msgbox_common') : popDiv = createpopDiv();
    var btn_title = (opts.btn_title)|| opts.title || '确定';
    var btn_class = (opts.btn_class) || '';
    var btn_payid = (opts.btn_payid || opts.pid) || '';
    var fn = opts.fn || opts.btn_fn || '';
    if (btn_payid) {
        btn_payid = 'pid="' + btn_payid + '"';
    }
    if(fn) {
        opts.btn_href = opts.btn_href || 'javascript:;';
    }
    var btn_href = (opts.btn_href) || 'javascript:msgExit()';
    var btn_target = (opts.btn_target == 1) ? '_blank' : '';
    var clickid = "";
    if (opts['boxTitle']) {
        opts['boxTitle'] ? opts['boxTitle'] = opts['boxTitle'] : opts['boxTitle'] = '温馨提示';
        popDiv.find('[name=boxTitle]').html(opts['boxTitle']);
    } else {
        popDiv.find('[name=boxTitle]').html('温馨提示');
    }

    popDiv.find("[name=msgbox_info]").html(msg);
    var btn = popDiv.find('[name=box_btn]');
    btn.replaceWith('<a class="act-pop-btn act-pop-btn-hot ' + btn_class + '" ' + clickid + ' ' + btn_payid + ' href="' + btn_href + '" name="box_btn" title="' + btn_title + '" target="' + btn_target + '">' + btn_title + '</a>');
    if (opts && opts['close_href']) { //修改点击关闭的操作
        var btn = popDiv.find('a.act-pop-close');
        btn.replaceWith('<a href="' + opts['close_href'] + '" title="关闭" class="act-pop-close act_close_box">关闭</a>');
    }
    popDiv.find('[name=box_btn]').on('click', function(){
        fn && fn();
    });
    createBackground(opts);
    popDiv.show();
    if (backDiv) {
        backDiv.show();
    }
    refreshBind();
};
/**
 * 显示指定id的div
 * 调用方式：showDiv('showdiv',{opacity:0});
 */
showmsg.show = function(id, opts) {
    exit();
    opts = opts || {};
    popDiv = $('#' + id);
    popDiv.show();
    createBackground(opts);
    if (backDiv) {
        backDiv.show();
    }
    if(opts.only) {
        refreshBackground();
    } else {
        refreshBind();
    }
};

showmsg.showErrorMsg = function(MSGID, opts) {
    if (active_cfg && active_cfg['msg']) {
        var MSG = active_cfg['msg'][MSGID];
    }
    if (MSG) {
        opts = {
            btn_title: MSG['btn_text'],
            btn_href: MSG['btn_link'],
            btn_target: MSG['btn_action'],
            boxTitle: MSG['title'],
            btn_class: MSG['btn_class'],
            btn_payid: MSG['btn_payid']
        };
        showmsg(MSG['content'], opts);
    } else {
        showmsg(MSGID, opts);
    }
}

function exit() {
    if (popDiv) popDiv.hide();
    if (backDiv) backDiv.remove();
};

function createpopDiv(opts) {
    var style = (opts && opts.style) || 'common';
    switch (style) {
        case 'common':
            popDiv = $(msgbox_tpl);
            popDiv.appendTo('body');
            break;
        default:
            break;
    }
    return popDiv;
}

/**
 * 创建背景层
 * 如果有指定背景层的id则直接显示该层
 */
function createBackground(opts) {
    var opacity = (opts && opts.opacity) == undefined ? 40 : opts.opacity;
    if (opacity > 0) {
        backDiv = $('<div></div>');
        backDiv.css({
            backgroundColor: "black",
            minWidth: '960px',
            filter: "alpha(opacity=" + opacity + ")",
            opacity: opacity / 100,
            position: 'fixed',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 100
        });
        backDiv.appendTo('body');
    }
}

//绑定事件
function refreshBind() {
    $(window).resize(function() {
        refreshBackground();
        refreshPop();
    });
    refreshBackground();
    refreshPop();
}

function refreshPop() {
    var divHeight = parseInt(popDiv.outerHeight());
    var divWidth = parseInt(popDiv.outerWidth());
    var divLeft = parseInt((document.documentElement.clientWidth - divWidth) / 2);

    var top = 0;
    top = document.body.scrollTop || document.documentElement.scrollTop + 50;
    var client_top = (document.documentElement.clientHeight - divHeight) / 2;

    var divTop = parseInt((top) + ((document.documentElement.clientHeight - divHeight) / 2));

    popDiv.css({
        position: 'fixed',
        top: client_top,
        left: divLeft,
        zIndex: 1002,
        marginLeft: 0,
        marginTop: 0
    });
}

function refreshBackground() {
    return
    if (backDiv) {
        var height = Math.max(document.body.scrollHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight);
        backDiv.width(Math.min(document.body.scrollWidth, document.documentElement.scrollWidth));
        backDiv.height(height);
    }
}

showmsg.exit = window.msgExit = exit;
module.exports = showmsg;


//////////////////
// WEBPACK FOOTER
// ./src/common/msgbox.js
// module id = 1
// module chunks = 2